/* eslint-disable semi */
// Base URL for the water tank backend API
export const API_BASE_URL = "https://noorymtd-back.icrcompany.net";

// API version
export const API_VERSION = "v1";

// Full API base URL with version
export const API_URL = `${API_BASE_URL}/api/${API_VERSION}`;
